export default [
    { path: '/dashboard', component: require('./components/Dashboard.vue').default, meta: { permission: [] } },
    { path: '/bookings', component: require('./components/BookingList.vue').default, meta: { permission: [] } },
    { path: '*', component: require('./components/NotFound.vue').default, meta: { permission: [] }, name: 'notFound' }
];
